import React from 'react';
import {Link} from 'react-router-dom';
import {getSelectOption} from '../api/functions';
import fetch from "isomorphic-unfetch"
import Grid from "@material-ui/core/Grid";

const
    initialShowQuantity = 9,
    addShowQuantity = 9,
    sphereAll = 'Все';

class ProgramFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            programs:  [],
            programsCount: 0,
            showQuantity: initialShowQuantity,
            places: [],
            forWhom: [],
            spheres: [],
            current: {
                place: '',
                forWhom: '',
                sphere: ''
            },
            sortBy: {
                value: 'date',
                label: 'По новизне'
            }
        };
    }


    handleFilter = e => {
        e.persist();
        this.setState(prevState => {
            prevState.current[e.target.name] = e.target.value;
            return prevState;
        });
    };

    handleShowMoreClick = () => {
        this.setState(prevState => ({
            showQuantity: prevState.showQuantity + addShowQuantity
        }));
    };

    filterItems = item => {
        const {current} = this.state;

        return item.place === current.place && item.forWhom === current.forWhom && (item.sphere === current.sphere || current.sphere === sphereAll);
    };

    sortItems = (a, b) => {
        const {sortBy} = this.state;

        if (sortBy.value === 'date') {
            return Date.parse(b.date) - Date.parse(a.date);
        }

        if (sortBy.value === 'name') {
            return a.name.localeCompare(b.name);
        }
    };

    handleSphereSelect = sphere => {
        this.setState(prevState => {
            prevState.current.sphere = sphere.value;
            return prevState;
        });
    };

    handleSortSelect = sortBy => {
        this.setState({sortBy});
    };

    componentDidMount() {
    fetch("https://copp72.ru/api/site/program/catalog")
        .then(value => value.json())
        .then(catalog => {
            let currentPlace = '';
            let currentForWhom = '';
            let currentSphere =  sphereAll;
            if (catalog.places && catalog.places.length > 0) {
                currentPlace = catalog.places[0];
            }
            if (catalog.forWhom && catalog.forWhom.length > 0) {
                currentForWhom = catalog.forWhom[0];
            }
            this.setState({
                programsCount: (catalog.items || []).length,
                programs: catalog.items || [],
                places: catalog.places || [],
                forWhom: catalog.forWhom || [],
                spheres: catalog.spheres || [],
                current: {
                    place: currentPlace,
                    forWhom: currentForWhom,
                    sphere: currentSphere
                },
            });
        })
}

    render() {
        const {
            places,
            forWhom,
            spheres,
            current,
            programs,
            showQuantity,
            programsCount
        } = this.state;

        const selectSpheres = [getSelectOption(sphereAll)];

        spheres.forEach(item => {
            selectSpheres.push(getSelectOption(item));
        });

        const selectSortBy = [];

        selectSortBy.push({
            value: 'name',
            label: 'По названию'
        });
        selectSortBy.push({
            value: 'date',
            label: 'По новизне'
        });

        console.log(programs);
        const items = programs;

        return (

            <div>
                <div className="program-filter">
                    <div className="program-filter-list">
                        <Grid container spacing={5}>
                            {items.length ? items.map((item, index) => (
                              <Grid item xs={12} sm={6} md={4} lg={3}>
                                <Link to={`/work/app/catalog${item.link}`} className="program-list-item" key={index}>
                                    <div className="program-list-item__for">{item.forWhom}</div>

                                    {item.tag && <div className="program-list-item__tag">{item.tag}</div>}

                                    <div className="program-list-item__img">
                                        <img src={`https://copp72.ru${item.img}`} alt=""/>

                                        <div className="program-list-item__arrow">

                                        </div>
                                    </div>

                                    <div className="program-list-item-info">
                                        <div className="program-list-item__name">{item.name}</div>

                                        <div className="program-list-item-info__bottom">
                                            <div className="program-list-item__data-item">
                                                <svg width="10" height="12" viewBox="0 0 10 12" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M7.95622 1.22628C7.1679 0.437956 6.1168 0 5.00001 0C3.88323 0 2.83213 0.437956 2.02191 1.22628C0.554758 2.69343 0.379576 5.45255 1.62775 7.13869L5.00001 12L8.35038 7.13869C9.62045 5.45255 9.42337 2.69343 7.95622 1.22628ZM5.04381 5.69343C4.18979 5.69343 3.51096 5.0146 3.51096 4.16058C3.51096 3.30657 4.18979 2.62774 5.04381 2.62774C5.89782 2.62774 6.57666 3.30657 6.57666 4.16058C6.57666 5.0146 5.87593 5.69343 5.04381 5.69343Z"
                                                        fill="#D0101B"/>
                                                </svg>

                                                <span>{item.place}</span>
                                            </div>

                                            <div className="program-list-item__data-item">
                                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M6 0C2.69136 0 0 2.69136 0 6C0 9.30864 2.69136 12 6 12C9.30864 12 12 9.30864 12 6C12 2.69136 9.30864 0 6 0ZM6 10.716C3.39506 10.716 1.28395 8.59259 1.28395 6C1.28395 3.40741 3.40741 1.28395 6 1.28395C8.59259 1.28395 10.716 3.40741 10.716 6C10.716 8.59259 8.60494 10.716 6 10.716Z"
                                                        fill="#D0101B"/>
                                                    <path
                                                        d="M9.12347 5.81484H6.43211V2.56792C6.43211 2.29632 6.20989 2.0741 5.93829 2.0741C5.66668 2.0741 5.44446 2.29632 5.44446 2.56792V6.30866C5.44446 6.58027 5.66668 6.80249 5.93829 6.80249H9.12347C9.39507 6.80249 9.6173 6.58027 9.6173 6.30866C9.6173 6.03706 9.39507 5.81484 9.12347 5.81484Z"
                                                        fill="#D0101B"/>
                                                </svg>

                                                <span>{item.duration}</span>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                              </Grid>
                            )) : <>
                                <span className="program-filter-list__no-results">По заданным параметрам ничего не найдено</span>
                                <span className="program-filter-list__no-results_fill">В настоящее время сайт находится на стадии наполнения. <br/> Если вы не смогли найти интересующую программу - напишите нам, либо позвоните по контактным телефонам.</span>
                            </>}
                        </Grid>
                    </div>
                </div>
            </div>
        );
    }
}

export {ProgramFilter};
